export enum LanguageLocales {
    AF = 'af',
    EN = 'en',
}
